import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { RushGameHistoryDto } from '@rush-core/dtos/rush-game-history.dto'
import { RushGameService } from '@rush-shared/services'

@Component({
  selector: 'app-trend',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './trend.component.html',
  styleUrls: ['./trend.component.sass'],
})
export class TrendComponent {
  constructor(private _rushGameService: RushGameService) {}

  // Define the colors for each type of bet
  betColors: any = {
    PAIR: 'green',
    INBETWEEN: 'blue',
    OUTBEYOND: 'red',
    TRIO: 'yellow',
  }

  // Define the number of rows
  rows = Array(7).fill(null)

  // Access game histories from the service
  get histories(): RushGameHistoryDto[] {
    return this._rushGameService.gameHistories
  }

  // Dynamically calculate the number of columns
  get columnCount(): number {
    if (this.histories.length > this.rows.length * 40) {
      return Math.ceil(this.histories.length / this.rows.length)
    } else {
      return 40
    }
  }

  // Generate a 2D array for colors based on the grid size
  get colors(): string[][] {
    const colors: string[][] = Array.from({ length: this.rows.length }, () =>
      Array(this.columnCount).fill('transparent'),
    )

    const sortedHistories = this.histories.slice().sort((a, b) => a.id - b.id)

    sortedHistories.slice(0, this.rows.length * this.columnCount).forEach((history, index) => {
      const columnIndex = Math.floor(index / this.rows.length)
      const rowIndex = index % this.rows.length
      colors[rowIndex][columnIndex] = this.betColors[history.winningBet] || 'transparent'
    })

    return colors
  }
}
